module.exports = __webpack_public_path__ + "img/segmented-nav.eb48f380.svg";